import { TimeoutError } from './base.js';
import { GenericError } from './genericError.js';

/**
 * Тип ошибки `BadStatusCodeError` не совпадает с именем ошибки по историческим причинам,
 * менять его не стоит, потому что в ELK/Grafana может быть завязано большое количество
 * алертов
 */
const BAD_STATUS_CODE_ERROR_TYPE = 'BadStatusCodeError';
class HttpBadStatusCodeError extends GenericError {
    static is(value) {
        return GenericError.is(value) && value.type === BAD_STATUS_CODE_ERROR_TYPE;
    }
    static isLike(value) {
        return (GenericError.isLike(value) &&
            (Object.getPrototypeOf(value).constructor.name === BAD_STATUS_CODE_ERROR_TYPE ||
                Object.getPrototypeOf(value).constructor.name === HttpBadStatusCodeError.name));
    }
    static formatMessage(url, statusCode) {
        return `HTTP api ${url} answers with not allowed status code: ${statusCode}`;
    }
    type = BAD_STATUS_CODE_ERROR_TYPE;
    statusCode;
    constructor(params) {
        const { domain, statusCode, url, details, message: originalMessage } = params;
        let message;
        if (originalMessage) {
            message = originalMessage;
        }
        else {
            if (url) {
                message = HttpBadStatusCodeError.formatMessage(url, statusCode);
            }
            else {
                message = `HTTP api answers with not allowed status code: ${statusCode}`;
            }
        }
        super({ type: BAD_STATUS_CODE_ERROR_TYPE, domain, message, details });
        if (typeof params === 'string') {
            this.statusCode = statusCode;
        }
        else {
            this.statusCode = params.statusCode;
        }
        Object.setPrototypeOf(this, HttpBadStatusCodeError.prototype);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, HttpBadStatusCodeError);
        }
        else {
            this.stack = new Error().stack;
        }
    }
    toStructuredClone() {
        const struct = super.toStructuredClone();
        struct[1].statusCode = this.statusCode;
        return struct;
    }
}
const TIMEOUT_ERROR_TYPE = 'HttpTimeoutError';
class HttpTimeoutError extends GenericError {
    static is(value) {
        return (GenericError.is(value) &&
            (value.type === TIMEOUT_ERROR_TYPE ||
                // В старых реализация @cian/http-api, у ошибки был `type: TimeoutError`
                (TimeoutError.is(value) && HttpTimeoutError.isLike(value))));
    }
    static isLike(value) {
        return GenericError.isLike(value) && Object.getPrototypeOf(value).constructor.name === TIMEOUT_ERROR_TYPE;
    }
    static formatMessage(url, timeout) {
        return `HTTP api ${url} not connected in ${timeout} ms`;
    }
    type = TIMEOUT_ERROR_TYPE;
    timeout;
    constructor(params) {
        const { timeout, url, message: originalMessage, domain, details } = params;
        let message;
        if (originalMessage) {
            message = originalMessage;
        }
        else {
            if (url) {
                message = HttpTimeoutError.formatMessage(url, timeout);
            }
            else {
                message = `HTTP api not connected in ${timeout} ms`;
            }
        }
        super({ type: TIMEOUT_ERROR_TYPE, domain, message, details });
        this.timeout = timeout;
        Object.setPrototypeOf(this, HttpTimeoutError.prototype);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, HttpTimeoutError);
        }
        else {
            this.stack = new Error().stack;
        }
    }
}
const BODY_PARSE_ERROR_TYPE = 'HttpBodyParseError';
class HttpBodyParseError extends GenericError {
    static is(value) {
        return GenericError.is(value) && value.type === BODY_PARSE_ERROR_TYPE;
    }
    static isLike(value) {
        return GenericError.isLike(value) && Object.getPrototypeOf(value).constructor.name === BODY_PARSE_ERROR_TYPE;
    }
    static formatMessage(url, statusCode, responseType) {
        return `Не удалось разобрать тело ответа ${responseType} ${url}, код ответа: ${statusCode}`;
    }
    type = BODY_PARSE_ERROR_TYPE;
    constructor(params) {
        const { statusCode, responseType, url, message: originalMessage, domain, details } = params;
        let message;
        if (originalMessage) {
            message = originalMessage;
        }
        else {
            if (url) {
                message = HttpBodyParseError.formatMessage(url, statusCode, responseType);
            }
            else {
                message = `Не удалось разобрать тело ответа ${responseType}, код ответа: ${statusCode}`;
            }
        }
        super({ type: BODY_PARSE_ERROR_TYPE, domain, message, details });
        Object.setPrototypeOf(this, HttpBodyParseError.prototype);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, HttpBodyParseError);
        }
        else {
            this.stack = new Error().stack;
        }
    }
}
/**
 * Тип ошибки `CancelError` не совпадает с именем ошибки по историческим причинам,
 * менять его не стоит, потому что в ELK/Grafana может быть завязано большое количество
 * алертов
 */
const CANCEL_ERROR_TYPE = 'CancelError';
class HttpCancelError extends GenericError {
    static is(value) {
        return GenericError.is(value) && value.type === CANCEL_ERROR_TYPE;
    }
    static isLike(value) {
        return GenericError.isLike(value) && Object.getPrototypeOf(value).constructor.name === HttpCancelError.name;
    }
    type = CANCEL_ERROR_TYPE;
    constructor(message, domain) {
        super({ type: CANCEL_ERROR_TYPE, domain, message });
        Object.setPrototypeOf(this, HttpCancelError.prototype);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, HttpCancelError);
        }
        else {
            this.stack = new Error().stack;
        }
    }
}

export { BAD_STATUS_CODE_ERROR_TYPE, HttpBadStatusCodeError, HttpBodyParseError, HttpCancelError, HttpTimeoutError };
//# sourceMappingURL=http.js.map
